import { render } from "./FlagIcon.vue?vue&type=template&id=141dd2de&scoped=true"
import script from "./FlagIcon.vue?vue&type=script&lang=js"
export * from "./FlagIcon.vue?vue&type=script&lang=js"

import "./FlagIcon.vue?vue&type=style&index=0&id=141dd2de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141dd2de"]])

export default __exports__